import {management} from '../../../..'

import { GetLastRecordFromManagementByIdSectorUseCase } from "./getLastRecordManagementById";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const getLastRecordFromManagementByIdSector=()=>{
  const repository=new ManagementRepository(management)

  const getLastRecord= new  GetLastRecordFromManagementByIdSectorUseCase(repository)

  return getLastRecord
}
